/**
 * Single bundle that exposes tiny-slider as window.tns.
 * Load this before any block script that uses the slider (hero-callout, content-slider, etc.)
 * so Parcel does not code-split and break chunk loading when scripts are loaded from dist/blocks/.
 */
import { tns } from "./tiny-slider/src/tiny-slider";
if (typeof window !== "undefined") {
    window.tns = tns;
}
